// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody__cmqzs"};